import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../actions/api"; // Reuse your axios instance
import { hideLoader, showLoader } from "./loaderSlice";
import { showSnackBar } from "./snackSlice";

// GET all facilities and filter for type = Devices
export const getDevices = createAsyncThunk(
  "device/getDevices",
  async (_, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).get(
        "/getall/clinic/facilities?page=1&itemSize=100"
      );
      if (res.status === 200) {
        const devices = res.data.data.filter((item) => item.type === "Devices");
        thunkAPI.dispatch(hideLoader());
        return devices;
      }
      thunkAPI.dispatch(hideLoader());
      return [];
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Failed to fetch devices", type: "error" })
      );
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// POST create device
export const createDevice = createAsyncThunk(
  "device/createDevice",
  async ({ name, type, status = true }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).post(
        `/create/clinic/facilites?type=${type}&name=${name}&status=${status}`
      );
      if (res.status === 200 || res.status === 201) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Device created successfully!",
            type: "success",
          })
        );
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to create device");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Failed to create device", type: "error" })
      );
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// PUT update device
export const updateDevice = createAsyncThunk(
  "device/updateDevice",
  async ({ id, name, type, status = true }, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).put(
        `/update/clinic/facilites/${id}?type=${type}&name=${name}&status=${status}`
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Device updated successfully!",
            type: "success",
          })
        );
        return res.data.data;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to update device");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Failed to update device", type: "error" })
      );
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

// DELETE device
export const deleteDevice = createAsyncThunk(
  "device/deleteDevice",
  async (id, thunkAPI) => {
    try {
      thunkAPI.dispatch(showLoader());
      const res = await api({ contentType: true, auth: true }).delete(
        `/delete/clinic/facilites/${id}`
      );
      if (res.status === 200) {
        thunkAPI.dispatch(hideLoader());
        thunkAPI.dispatch(
          showSnackBar({
            message: "Device deleted successfully!",
            type: "success",
          })
        );
        return id;
      }
      thunkAPI.dispatch(hideLoader());
      return thunkAPI.rejectWithValue("Failed to delete device");
    } catch (err) {
      thunkAPI.dispatch(hideLoader());
      thunkAPI.dispatch(
        showSnackBar({ message: "Failed to delete device", type: "error" })
      );
      return thunkAPI.rejectWithValue(err.response?.data || err.message);
    }
  }
);

const deviceSlice = createSlice({
  name: "device",
  initialState: {
    devices: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDevices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDevices.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = action.payload;
      })
      .addCase(getDevices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.devices.push(action.payload);
      })
      .addCase(createDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateDevice.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.devices.findIndex(
          (d) => d.facilityId === action.payload.facilityId
        );
        if (index !== -1) {
          state.devices[index] = action.payload;
        }
      })
      .addCase(updateDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteDevice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteDevice.fulfilled, (state, action) => {
        state.loading = false;
        state.devices = state.devices.filter(
          (d) => d.facilityId !== action.payload
        );
      })
      .addCase(deleteDevice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default deviceSlice.reducer;
